import { ThunkType } from "../../../../../core/store/reducers";
import { getWeightedPriceReport } from "../api/getWeightedPriceReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../weightedPriceDataSlice";

export const downloadWeightedPriceReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchbusiness.weightedPrice;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(getWeightedPriceReport(user, filter));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "WeightedPrice.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
